import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SysSettingPage } from './sys-setting.page';

const routes: Routes = [
  {
    path: '',
    component: SysSettingPage
  },
  {
    path: 'message-setting',
    loadChildren: () => import('./message-setting/message-setting.module').then( m => m.MessageSettingPageModule)
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./privacy-policy/privacy-policy.module').then( m => m.PrivacyPolicyPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SysSettingPageRoutingModule {}
